export enum ProfileSettingsMenu {
  PROFILE = 'profile',
  USERS = 'users',
  SUBSCRIPTIONS = 'subscriptions',
}
